import { fetchLogOut, fetchPreregister } from 'containers/Login/loginSlice'
import { clearWarehousesList } from 'containers/Warehouses/warehousesSlice'
import { useHistory } from 'react-router-dom'
import { useReduxDispatch } from 'store'
import { useState } from 'react'

interface SwitchAccountOptions {
  recoveryLogin?: { phone?: string, prefix?: string, email?: string }
}

const useSwitchAccount = () => {
  const [isPending, setPending] = useState(false)
  const dispatch = useReduxDispatch()
  const { replace } = useHistory()

  const switchAccount = async (path = '/login', { recoveryLogin }: SwitchAccountOptions = {}) => {
    if (isPending) return
    setPending(true)

    try {
      const result = await dispatch(fetchLogOut())
      if (result?.meta?.requestStatus !== 'fulfilled') throw new Error('Logout failed')
      dispatch(clearWarehousesList())
    } catch (error) {
      console.error(error)
      setPending(false)
      return
    }

    if (recoveryLogin) {
      try {
        await dispatch(fetchPreregister(recoveryLogin)).unwrap()
      } catch (error) {
        console.warn('Fetch preregister failed')
      }
    }

    replace(path)
  }

  return { switchAccount, isPending }
}

export default useSwitchAccount
